var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{attrs:{"body-style":{
        textAlign: 'left',
        padding: '15px',
        height: '100%'
    },"shadow":"always"}},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_vm._v(" 资料下载 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }